<template>
	<b-modal
		size="xmd"
		ref="specimen-locations-modal"
		@hidden="$emit('close')"
		ok-title="Guardar"
		:title="`Ubicaciones`"
		centered
		no-close-on-backdrop
		scrollable
		hide-footer
	>
		<b-card no-body class="p-1">
			<b-nav tabs>
				<b-nav-item
					v-for="area in locationAreas"
					:key="`areax-${area.id}`"
					@click="changeArea(area.id)"
					:active="area.id === area_id"
				>
					{{ area.name }}
				</b-nav-item>
			</b-nav>
			<b-nav tabs>
				<b-nav-item
					v-for="type in locationTypes"
					:key="`type-${type.id}`"
					@click="changeType(type.id)"
					:active="type.id === type_id"
				>
					{{ type.name }}
				</b-nav-item>
			</b-nav>
			<b-nav class="text-success" tabs>
				<b-nav-item
					v-for="locationStatus in locationStatuses"
					:key="`status-${locationStatus.id}`"
					:active="locationStatus.id === status"
					@click="changeStatus(locationStatus.id)"
				>
					<div :class="`text-${locationStatus.id === 'LIBRE' ? 'success' : 'danger'}`">
						{{ locationStatus.name }}
					</div>
				</b-nav-item>
			</b-nav>
			<b-row class="mb-1">
				<b-col class="d-flex align-items-center">
					<small class="text-secondary">
						Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} registros
					</small>
				</b-col>
				<b-col class="d-flex align-items-center justify-content-end flex-wrap gap-x-4 gap-y-1">
					<b-pagination
						v-model="pagination.curPage"
						:total-rows="pagination.total"
						:per-page="pagination.perPage"
						first-number
						last-number
						class="mb-0 mt-1 mt-sm-0"
						prev-class="prev-item"
						next-class="next-item"
					>
						<template #prev-text>
							<feather-icon icon="ChevronLeftIcon" size="18" />
						</template>
						<template #next-text>
							<feather-icon icon="ChevronRightIcon" size="18" />
						</template>
					</b-pagination>
				</b-col>
			</b-row>
			<b-row class="mb-1">
				<b-col cols="12" xl="7" class="d-flex align-items-center justify-content-start mb-md-0">
					<label>Mostrar</label>
					<v-select
						v-model="pagination.perPage"
						:options="perPageOptions"
						:clearable="false"
						class="per-page-selector d-inline-block mx-50"
						style="width: 90px"
					/>
					<label class="mr-2">registros</label>
					<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refresh" />
				</b-col>
				<b-col cols="12" xl="5">
					<div class="container-btns-page-specimens">
						<div class="d-flex">
							<b-input-group id="cintillo-ala-input-group">
								<b-form-input
									v-model="search"
									class="d-inline-block"
									:placeholder="`Por ubicación ${status == 'OCUPADO' ? 'o ejemplar' : ''}`"
									@keyup.enter="handleInputSearch"
									debounce="500"
								/>
								<b-input-group-append>
									<b-button variant="outline-primary" @click="handleInputSearch()">
										<feather-icon class="cursor-pointer" icon="SearchIcon" />
									</b-button>
								</b-input-group-append>
							</b-input-group>
						</div>
					</div>
				</b-col>
			</b-row>
			<b-row v-if="status == 'OCUPADO' && selectedLocations.length > 0">
				<b-col cols="12" class="d-flex align-items-center justify-content-end">
					<b-button
						variant="outline-primary"
						@click="showSelectedSpecimens = true"
						:disabled="selectedLocations.length === 0"
					>
						<b-badge v-if="selectedLocations.length > 0" variant="danger">
							{{ selectedLocations.length }}
						</b-badge>
						Ubicaciones Seleccionadas
					</b-button>
				</b-col>
			</b-row>
			<b-table-simple responsive sticky-header="50vh" no-border-collapse class="mt-2">
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-th class="text-center" v-if="status == 'OCUPADO'"></b-th>
					<b-th class="text-center">Ubicación</b-th>
					<b-th class="text-center">Estado</b-th>
					<b-th class="text-center">Ejemplar</b-th>
				</b-thead>
				<b-tbody>
					<template v-if="locationDetails.length > 0">
						<b-tr v-for="(detail, index) in locationDetails" :key="index">
							<b-td v-if="status == 'OCUPADO'" class="text-center">
								<div class="d-flex align-items-center justify-content-center">
									<b-checkbox
										v-model="detail.selected"
										@input="(e) => handleCheckboxChange(e, detail)"
									/>
								</div>
							</b-td>
							<b-td class="text-center">
								<div>{{ formatLocationName(detail.area_name, detail.name) }}</div>
							</b-td>
							<b-td class="text-center">
								<div>{{ detail.status }}</div>
							</b-td>
							<b-td class="text-center">
								<SpecimenPlate v-if="detail.specimen" :specimen="detail.specimen" show_status />
								<b-button
									v-else
									@click=";(showSearchFreeSpecimenModal = true), (selectedLocation = detail)"
									variant="outline-primary"
								>
									<FeatherIcon icon="PlusIcon" size="16" />
								</b-button>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="locationDetails.length === 0">
						<b-td colspan="10" class="text-center" style="height: 80px">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-card>
		<SearchFreeSpecimenModal
			v-if="showSearchFreeSpecimenModal"
			@close="showSearchFreeSpecimenModal = false"
			:location="selectedLocation"
			@refresh="getLocationDetails"
		/>
		<b-modal
			v-model="showSelectedSpecimens"
			size="lg"
			title="Ejemplares Seleccionados"
			centered
			no-close-on-backdrop
			scrollable
			:ok-title="`Liberar`"
			@ok.prevent="releaseSpecimens"
			:ok-disabled="!selectedLocations.length"
			@hidden="showSelectedSpecimens = false"
		>
			<b-table-simple responsive sticky-header="50vh" no-border-collapse class="mt-2">
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-th class="text-center">Ubicación</b-th>
					<b-th class="text-center">Estado</b-th>
					<b-th class="text-center">Ejemplar</b-th>
					<b-th class="text-center">Acciones</b-th>
				</b-thead>
				<b-tbody>
					<template v-if="selectedLocations.length > 0">
						<b-tr v-for="(detail, index) in selectedLocations" :key="index">
							<b-td class="text-center">
								<div>{{ formatLocationName(detail.area_name, detail.name) }}</div>
							</b-td>
							<b-td class="text-center">
								<div>{{ detail.status }}</div>
							</b-td>
							<b-td class="text-center">
								<SpecimenPlate :specimen="detail.specimen" show_status />
							</b-td>
							<b-td class="text-center">
								<FeatherIcon
									icon="Trash2Icon"
									class="cursor-pointer text-danger"
									size="20"
									@click="removeLocation(detail.id)"
								/>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="selectedLocations.length === 0">
						<b-td colspan="10" class="text-center" style="height: 80px">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-modal>
	</b-modal>
</template>

<script>
import SpecimenLocationService from "@/views/brain/specimens/views/location/services/specimen-location.service.js"
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import SearchFreeSpecimenModal from "@/views/amg/specimens/components/SearchFreeSpecimenModal.vue"
export default {
	name: "SearchLocationModal",
	props: {},
	components: {
		SearchFreeSpecimenModal,
		SpecimenPlate,
	},
	async mounted() {
		await this.getLocationDetails()
		this.$refs["specimen-locations-modal"].toggle()
	},
	data() {
		return {
			showSelectedSpecimens: false,
			selectedLocation: null,
			locationAreas: [
				{
					id: 1,
					name: "Preparación",
				},
				{
					id: 2,
					name: "Encaste",
				},
			],
			locationTypes: [
				{
					id: 1,
					name: "Casilla",
				},
				{
					id: 2,
					name: "Rascadero",
				},
				{
					id: 3,
					name: "Voladero",
				},
			],
			locationStatuses: [
				{
					id: "LIBRE",
					name: "Libres",
				},
				{
					id: "OCUPADO",
					name: "Ocupadas",
				},
			],
			locations: [],
			locationDetails: [],
			selectedLocations: [],
			area_id: 1,
			type_id: 1,
			status: "LIBRE",
			search: "",
			perPageOptions: [10, 25, 50],
			pagination: {
				total: 0,
				curPage: 1,
				perPage: 25,
				from: 0,
				to: 0,
			},
			showSearchFreeSpecimenModal: false,
		}
	},

	methods: {
		formatLocationName(locationAreaName, locationName) {
			const parts = locationName.split(" ")
			if (parts.length >= 2) {
				const prefix = parts[0].substring(0, 3).toUpperCase()
				const suffix = parts[parts.length - 1]
				return `${locationAreaName.substring(0, 3).toUpperCase()}-${prefix}-${suffix}`
			}
			return locationAreaName.substring(0, 3).toUpperCase() + locationName.substring(0, 3).toUpperCase()
		},
		async releaseSpecimens() {
			const { isConfirmed } = await this.showConfirmSwal({
				text: `Se liberaran ${this.selectedLocations.length} ubicaciones`,
			})
			if (!isConfirmed) return
			this.isPreloading()
			try {
				await SpecimenLocationService.releaseSpecimens({
					ids: this.selectedLocations.map((detail) => detail.id),
				})
				this.selectedLocations = []
				this.showSelectedSpecimens = false
				this.getLocationDetails()
				this.showSuccessToast("Ubicaciones liberadas correctamente")
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		removeLocation(locationId) {
			this.selectedLocations = this.selectedLocations.filter((loc) => loc.id !== locationId)
			this.locationDetails = this.locationDetails.map((detail) => {
				if (detail.id === locationId) {
					return {
						...detail,
						selected: false,
					}
				}
				return detail
			})
		},
		refresh() {
			this.search = ""
			this.getLocationDetails()
		},
		handleCheckboxChange(e, location) {
			if (e) {
				if (this.selectedLocations.some((loc) => loc.id === location.id)) return
				this.selectedLocations.push(location)
			} else {
				this.selectedLocations = this.selectedLocations.filter((l) => l.id !== location.id)
			}
		},
		handleInputSearch() {
			this.getLocationDetails()
		},
		changeStatus(status) {
			this.isPreloading()
			this.status = status
			this.search = ""
			this.getLocationDetails()
		},
		changeArea(area_id) {
			this.area_id = area_id
			this.search = ""
			this.getLocationDetails()
		},
		changeType(type_id) {
			this.type_id = type_id
			this.search = ""
			this.getLocationDetails()
		},
		async getLocationDetails(page = 1) {
			this.isPreloading()
			try {
				const { data } = await SpecimenLocationService.getLocationDetails({
					ids: [],
					search: this.search,
					area_id: this.area_id,
					type_id: this.type_id,
					status: this.status,
					page: page,
					per_page: this.pagination.perPage,
				})
				this.pagination.curPage = data.current_page
				this.pagination.total = data.total
				this.pagination.from = data.from
				this.pagination.to = data.to
				this.locationDetails = data.data.map((detail) => {
					return {
						...detail,
						selected: this.selectedLocations.some((loc) => loc.id === detail.id),
					}
				})
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
	},
	watch: {
		"pagination.curPage": async function () {
			await this.getLocationDetails(this.pagination.curPage)
		},
		"pagination.perPage": async function () {
			await this.getLocationDetails()
		},
	},
}
</script>

<style scoped></style>
